import { Role } from '../generated/graphql';

/**
 * Role sets the route guards admit — the ONE source of truth shared by the guards and the
 * sidebar, so a nav entry can never point at a page its guard refuses
 * (YOJO-3387 [nurses see a CRM sidebar entry that bounces]).
 */

/** Roles `AdminOrOperationsRoute` admits. */
export const ADMIN_OR_OPERATIONS_ROLES: readonly Role[] = [Role.Admin, Role.Operations];

/**
 * Roles the `/crm` `RoleRoute` admits: admin and operations, plus sales for CRM → Partner
 * Enquiries (YOJO-3371 [care-portal CRM page for partner enquiries]).
 */
export const CRM_ROLES: readonly Role[] = [Role.Admin, Role.Operations, Role.Sales];

/**
 * Top-level nav paths whose parent route is guarded, mapped to the roles that guard admits.
 * A path absent here has no guard on its parent route, so the sidebar adds no extra filter.
 */
export const ROUTE_ROLES: Readonly<Record<string, readonly Role[]>> = {
  '/crm': CRM_ROLES,
  '/operations': ADMIN_OR_OPERATIONS_ROLES,
};

/** True when any of `roles` is in `allowed`. */
export function hasAnyAllowedRole(roles: readonly string[], allowed: readonly Role[]): boolean {
  return roles.some((role) => (allowed as readonly string[]).includes(role));
}
